import React, { useState, useEffect, useCallback } from "react";
import "./index.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import axios from "./../../axios";
import Checkbox from "@material-ui/core/Checkbox";
import { blue } from "@material-ui/core/colors";
import {
  mappingExistOrNot,
  removeMapping,
  fetchTableChildren,
} from "../../components/IFormDesignerLayout/RequestLogic";
import { useTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import styles from "./TreeMapFile.module.css";
import RedCross from "../../Icons/RedCross";
import Tree from "./TreeMapFile";
import { findDataObjectListView, getFormId, parentFrameMappedId } from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import { GetState, GetStateFromData } from "../../components/CustomHooks/CustomHooks";
import { useDispatch } from "react-redux";
import { updateStateInRedux } from "../../Redux";
import { recursiveJsonReader1 } from "../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import CustomizedAlert from "../Alert/CustomizedAlert";

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => (
  <Checkbox
    color="default"
    {...props}
    aria-label="Data Object"
    inputProps={{ "aria-label": "Data Object" }}
  />
));

const BlueCheckbox = withStyles({
  root: {
    color: blue[400],
    "&$checked": {
      color: blue[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const TreeNode = ({
  node,
  elementType,
  mapId,
  setMapId,
  setMapValue,
  setMapType,
  showMapButton,
  setShowMapButton,
  setDataMapId,
  setUnmapJsonState,
  processVal,
  setProcessVal,
  mapBoundValue,
  setMapBoundValue,
  isWS,
  setParentObj,
  setUpdateList,
  setMapVariableType,
  setVarPrecision,
  setCurrentMappedElement,
  selectedVariableCallback = null,
  setVariableLength,
  setDataObjectType,
  setUnBounded,
  setSnackBarInfo,
  setAlertMsg,
  handleClose1,
  mappedContentForAdvance,
}) => {
  const contexts = GetStateFromData();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const { t } = useTranslation(["translation", "styles"]);
  const {
    updateJson,
    selectedControl,
    mappingControlsIdMap,
    dataObjectsContent,
    microFrontendData,
    activePage,
    formState2,
    activeSubForm,
    setCurrentMappedDO,
    currentMappedDO,
    filteredDataObjectCopy,
    filteredDataObject,
    openCanvasForSubform,
    // showAlertConfirmNotifications,
  } = contexts.contexts;
  const dispatch = useDispatch();
  const [alertData, setAlertData] = useState({
      open: false,
      showConfirm: "showNotification"
  });
  const { updatedComponentInFormState } = updateJson;
  const {frameDOChild} = GetState("frameDOChild");
  const parentFrameBuffer = parentFrameMappedId(formState2, selectedControl, selectedControl?.frameIndex)

  useEffect(() => {
    fetchingChildrenMapped2(node);
  }, [node.children]);

  const [childVisible, setChildVisiblity] = useState(
    node["MappingInfo"] ? true : false
  );

  const hasChild =
    (node.children && node.children?.length !== 0) || node["MappingInfo"]
      ? true
      : false;

  const fetchingChildrenMapped2 = useCallback(async (dataC) => {
    var ab = 1;
    if (ab === 1 && dataC.children === undefined && dataC["MappingInfo"]) {
          setChildVisiblity(!childVisible);
          window.loading(true)
          const jsonData = {
            parentTableId: dataC.VariableId,
            treeName: `${dataC.treeName}`,
            status: "1",
            formId: getFormId().toString()
          };
          await fetchTableChildren(jsonData).then((response) => {
            dataC.children = response.data["children"];
            setRenderInstant(dataC);
          });
          window.loading(false)
      }
  }, [])


  const [renderInstant, setRenderInstant] = useState();
  const [mappedObjects, setMappedObjects] = useState([]);
  useEffect(() => {
    findDataClass(formState2);
  }, []);

  function findDataClass(formState) {
    const mappedObjects = [];
    if (formState.children) {
      let arr = formState.children;
      for (let i of arr) {
        if (i.children) {
          findDataClass(i);
        }
        if (i.dataclass) {
          mappedObjects.push(i.dataclass);
        }
      }
      setMappedObjects(mappedObjects);
    } else {
      return;
    }
  }

  // function fetchingChildren(event, dataC) {
  //   setChildVisiblity(!childVisible);
  //   var ab = 1;
  //   if (
  //     ab === 0 &&
  //     childVisible === false &&
  //     dataC.children === undefined &&
  //     dataC["MappingInfo"]
  //   ) {
  //     var currName = dataC.VariableName;
  //     var parentname = currName;
  //     fetch("/mdm-rest/app/gettabledefinition", {
  //       method: "post",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         id: dataC.VariableId,
  //         name: parentname,
  //         status: "1",
  //       }),
  //     })
  //       .then(function (response) {
  //         return response.json();
  //       })
  //       .then(function (content) {
  //         var data = JSON.stringify(content.data);
  //         const jsonData = {
  //           formId: activePage?.formId,
  //           data: `${data}`,
  //         };

  //         axios
  //           .post("/idesign/gettableDefinition", jsonData, {
  //             withCredentials: true,
  //           })
  //           .then((response) => {
  //             dataC.children = response.data.children;
  //             setRenderInstant(dataC);
  //           })
  //           .catch(function (error) {
  //             if (error.response) {
  //             }
  //             console.log("error is", error);
  //           });
  //       })
  //       .catch((err) => {
  //         console.log("error is", err);
  //       });
  //   }
  // }

  const fetchingAllDataObjects = async (dataC) => {
    setChildVisiblity(!childVisible);
    var ab = 1;
    if (
      ab === 0 &&
      childVisible === false &&
      dataC.children === undefined &&
      dataC["MappingInfo"]
    ) {
    window.loading(true)
    const parentname = dataC?.VariableName

    const jsonData = {
      parentTableId: dataC ? (dataC?.VariableId ? dataC?.VariableId : "") : "",
      treeName: parentname || "",
      status: "1",
      formId: getFormId().toString()
    }

    await axios
    .post("/idesign/gettableDefinition", jsonData, {
      withCredentials: true,
    })
    .then((response) => {
      console.log(response)
      dataC.children = response.data.children;
      setRenderInstant(dataC);
    })
    .catch((error) => {
      if(error.response){
      }
      console.log("error", error)
    })
    window.loading(false)
  }
}

  function validateDoForDoclist(dataObj) {
    const defaultVars = [
      "doctype",
      "docname",
      "docsize",
      "resourcetype",
      "doccomment",
      "docindex",
      "noofpageindoc",
      "doccontrolid",
      "latitude",
      "longitude"
    ]

    if(!dataObj?.children || (dataObj?.children?.length < 10)) {
      return false;
    }

    let tempArr = [];

    dataObj.children.forEach((obj) => {
      if(defaultVars.includes(obj?.VariableName)) {
        tempArr.push(obj?.VariableName)
      }
    })

    if(tempArr.length === 10) return true;
    return false;

  }  

  function setMappingOnControl(event, data) {
    window.loading(true);
    var currName = data.VariableName;
    var pName = data?.parentName ? data?.parentName + "." : "";

    var varType = data.VariableType;

    var parentname = pName + currName;

    var unBounded = data.Unbounded;

    var processValue = false;

    var treeName = data.treeName;
    var hasChild;
    let dataObj = findDataObjectListView(
      dataObjectsContent,
      data.treeName,
      "children"
    );
    if (dataObj && dataObj.children && dataObj.children.length > 0) {
      hasChild = true;
    } else {
      hasChild = false;
    }

    if(elementType === "doclist" && (!validateDoForDoclist(dataObj))) {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `The selected data object is not valid for doclist`,
      });
      setShowMapButton("");
      window.loading(false);
      return;
    }

    if(selectedControl?.elem_type === "textbox" && data?.VariableType !== "String"){
      if(selectedControl?.style?.MaskingValue === "000-000" || selectedControl?.style?.MaskingValue === "email" || selectedControl?.style?.MaskingValue === "(00) 0000000000"){
        setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t("Textbox with input validation pincode, email or phone number can be mapped to data object of type String only")}`,
        });
        setShowMapButton("");
        window.loading(false);
        return;
      }
    }

    var jsonToSend = {
      mappedField: treeName,
      unbounded: data.Unbounded,
      isProcessVar:
        data.dataObjectType === "M"
          ? false
          : data.dataObjectType === "P"
          ? true
          : "",
      hasChild: hasChild,
      formId:
        microFrontendData?.formDefId ||
        activePage?.formId ||
        activeSubForm?.fragmentId ||
        microFrontendData?.processDefId ||
        microFrontendData?.templateId,
    };
    try {
      mappingExistOrNot(jsonToSend)
        .then((response) => {
          if (response.data.status === "-1") {
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: `mappingError`,
            });
            window.loading(false);
          }
          if (response.data.status === "0") {
            setUnmapJsonState(jsonToSend);
            if (dataObj?.treeName?.includes(".")) {
              const parentName = dataObj.parentName.split(".");
              setParentObj(parentName?.[0]);
            } else setParentObj(dataObj?.parentName || dataObj?.treeName);
            setCurrentMappedElement((prev) => [...prev, { jsonToSend }]);
            setCurrentMappedDO((prev) => {
              return [...prev, treeName];
            });
            if (
              elementType === "table" ||
              elementType === "listview" ||
              elementType === "advancelistView" ||
              elementType === "advancelistview"
            ) {
            }
            if(elementType === "frame" && data?.Unbounded === "Y"){
              dispatch(updateStateInRedux({name: "frameDOChild", value: {...frameDOChild, [selectedControl.id]: data?.children}}))
            }
            if (!data.VarPrecision) {
              data.VarPrecision = "2";
            }
            setMapValue(treeName);
            setDataMapId(data.VariableId);
            setMapId(treeName);
            setMapVariableType(data?.VariableType);
            setProcessVal(processValue);
            setMapBoundValue(unBounded);
            setVarPrecision(data?.VarPrecision);
            setVariableLength(data?.VariableLength);
            setDataObjectType(data?.dataObjectType);
            setUnBounded(data?.Unbounded);
            setShowMapButton("");
          }
          window.loading(false);
        })
        .catch((error) => {
          window.loading(false);
          console.log(error);
        });
    } catch (e) {
      window.loading(false);
      console.log(e);
    }

    event.stopPropagation();
    // window.loading(false)
  }

  function searchItemAndUpdate(children, searchItem) {
    for (let item of children) {
      if (item.children) {
        searchItemAndUpdate(item.children, searchItem);
      }
      if (item.treeName === searchItem) {
        item.isMapped = false;
      }
    }
  }

  function JsonUnMapButtonParent(event, data) {
    window.loading(true);
    var currName = data.VariableName;
    var pName = data?.parentName ? data?.parentName + "." : "";

    var parentname = pName + currName;
    var treeName = data.treeName;
    mappingControlsIdMap.delete(currName);
    var hasChild;

    if (data?.children) {
      if (data.children.length > 0) {
        hasChild = true;
      } else {
        hasChild = false;
      }
    } else {
      hasChild = false;
    }



    var jsonToSend = {
      mappedField: treeName,
      unbounded: data.Unbounded,
      isProcessVar:
        data.dataObjectType === "M"
          ? false
          : data.dataObjectType === "P"
          ? true
          : "",
      hasChild: hasChild,
      formId: activePage?.formId,
    };

    removeMapping(jsonToSend).then((response) => {
      searchItemAndUpdate(filteredDataObjectCopy, treeName);
      setMapValue("");
      setMapId("");
      setShowMapButton("");
      setProcessVal("");
      setMapBoundValue("");
      data["isMapped"] = false;
      setCurrentMappedDO((prev) => {
        const result = prev.filter((item) => item != treeName);
        return [...result];
      });
      if(elementType === "frame"){
        delete selectedControl?.style?.["SectionKeyField"]
        delete selectedControl?.style?.["SectionKeyValue"]
        delete frameDOChild?.[selectedControl.id]
        dispatch(updateStateInRedux({name: "frameDOChild", value: {...frameDOChild}}))
        updatedComponentInFormState(selectedControl.id ,selectedControl)
      }
      if(elementType === "textbox") {
        delete selectedControl?.style?.masking
        updatedComponentInFormState(selectedControl.id ,selectedControl)
      }
      window.loading(false);
    });
    setUpdateList(!true);
    event.stopPropagation();
  }
  function findParent(dataObjects, parent) {
    for (let i of dataObjects) {
      if (
        i.children &&
        (i["VariableName"] === parent || i["TableName"] === parent) &&
        i["Unbounded"] === "Y"
      ) {
        return i;
      } else {
        if (i.children) {
          return findParent(i.children, parent);
        }
      }
    }
  }

  function getParentType(data) {
    let nodes = data["treeName"].split(".");

    for (let parent = nodes.length - 2; parent >= 0; parent--) {
      let parentData = findParent(dataObjectsContent, nodes[parent]);
      if (parentData) return parentData;
    }
  }

  function returnOnlySelectedNode(event, data) {
    if (
      !selectedVariableCallback ||
      (data.children && data.children.length > 0)
    ) {
      return;
    }
    if (!data.children || data.children.length === 0) {
      let parentDetail = undefined;
      if (data["treeName"].includes(".")) {
        parentDetail = getParentType(data);
      }
      if (parentDetail && parentDetail.Unbounded === "Y") {
      } else {
        selectedVariableCallback(data["treeName"]);
      }
    }
  }
  function isValid(dataObjects, parentName) {
    for (let item of dataObjects) {
      if (
        item.treeName === parentName ||
        item.VariableName === parentName ||
        item.parentName === parentName
      ) {
        if (
          item.Unbounded === "N" &&
          (openCanvasForSubform !== "advanceListviewFromScratch" ||
            !openCanvasForSubform)
        ) {
          return true;
        } else if (
          item.Unbounded === "N" &&
          openCanvasForSubform === "advanceListviewFromScratch"
        ) {
          // setSnackBarInfo({ open1: true });
          setSnackBarInfo({
            open: true,
            showConfirm: "showNotification",
            alertType: "info",
            alertContentKey: "Control cannot be mapped.",
            autoHideDuration: 3000
          });
          // setAlertMsg("Control cannot be mapped.");
          // setTimeout(() => {
          //   handleClose1();
          // }, 3000);
          return false;
        }
        if (item.Unbounded === "Y" && item.isMapped === true) {
          return true;
        } else if (item.Unbounded === "Y" && item.isMapped === false) {
          // setSnackBarInfo({ open1: true });
          setSnackBarInfo({
            open: true,
            showConfirm: "showNotification",
            alertType: "info",
            alertContentKey: `${t(`translation:Please map the parent data object before proceeding with the nested variable`)}.`,
            autoHideDuration: 3000
          });
          // setAlertMsg(`${t(`translation:Please map the parent data object before proceeding with the nested variable`)}.`);
          // setTimeout(() => {
          //   handleClose1();
          // }, 3000);
          return false;
        }
      } else if (item.children && item.children.length > 0) {
        return isValid(item.children, parentName);
      }
    }
  }
  function isParentUnbounded(parentObject) {
    if (
      openCanvasForSubform === "advanceListviewFromScratch" &&
      (!parentObject.isMapped && parentObject.Unbounded === "Y") &&
      !currentMappedDO.includes(parentObject.treeName)
    ) {
      // setSnackBarInfo({ open1: true });
      setSnackBarInfo({
        open: true,
        showConfirm: "showNotification",
        alertType: "info",
        alertContentKey: `${t(`translation:Please map the parent data object before proceeding with the nested variable`)}.`,
        autoHideDuration: 3000
      });
      // setAlertMsg(`${t(`translation:Please map the parent data object before proceeding with the nested variable`)}.`);
      // setTimeout(() => {
      //   handleClose1();
      // }, 3000);
      return true;
    } else if (
      openCanvasForSubform === "advanceListviewFromScratch" &&
      (parentObject.isMapped || currentMappedDO.includes(parentObject.treeName))
    ) {
      return false;
    }  else if (  parentFrameBuffer && parentFrameBuffer?.dataclass && parentObject.Unbounded === "Y"){
      return false
    } else if (parentObject.Unbounded === "Y") {
      // setSnackBarInfo({ open1: true });
      setSnackBarInfo({
        open: true,
        showConfirm: "showNotification",
        alertType: "info",
        alertContentKey: `${t(`translation:Please map the parent data object before proceeding with the nested variable`)}.`,
        autoHideDuration: 3000
      });
      // setAlertMsg(`${t(`translation:Please map the parent data object before proceeding with the nested variable`)}.`);
      // setTimeout(() => {
      //   handleClose1();
      // }, 3000);
      return true;
    } else {
      return parentObject.Unbounded === "Y";
    }
  }
  function findParentForChild(childName, objects) {
    for (const obj of objects) {
      if (obj.VariableName === childName) {
        return isParentUnbounded(obj);
      } else {
        if (obj.children) {
          for (const child of obj.children) {
            if (child.VariableName === childName) {
              return isParentUnbounded(child); // Return true/false
            } else if (child.children) {
              const result = findParentForChild(childName, child.children);
              if (result !== null) {
                return result; // Return true/false from deeper levels
              }
            }
          }
        }
      }
    }
    return null; // Child not found
  }

  function findGrandParent(data, key) {
  function findTreeName(node, parent = null, grandParent = null) {
    if (!node) return null;

    if (node.treeName === key) {
      return grandParent?.Unbounded ?? null;
    }

    if (Array.isArray(node.children)) {
      for (let child of node.children) {
        const result = findTreeName(child, node, parent);
        if (result !== null) return result;
      }
    }

    return null;
  }

  // Since data is an array of root nodes
  for (let node of data) {
    const result = findTreeName(node);
    if (result !== null) return result;
  }

  return null;
}


  function setMapButton(event, data) {
    const isAdvanceListView = openCanvasForSubform === "advanceListviewFromScratch";
    const isGrandParentUnbounded = findGrandParent(filteredDataObject, data.treeName) === "Y";
    if (!isAdvanceListView && isGrandParentUnbounded) {
      setShowMapButton(""); 
      return;
    }
    if (selectedVariableCallback) {
      return;
    }
    if (data?.childListviewOrTableInsideAdvListview) {
      return;
    }
    if (findParentForChild(data.parentName, filteredDataObject)) return;

    if (mapId) {
      return;
    } else {
      let noChild;
      let dataObj = findDataObjectListView(
        dataObjectsContent,
        data.treeName,
        "children"
      );
      if (dataObj && dataObj.children && dataObj.children.length > 0) {
        noChild = false;
      } else {
        noChild = true;
      }
      setShowMapButton("");
      var treeName = data.treeName;

      if (data["Unbounded"] === "Y" && noChild && elementType === "listbox") {
        setShowMapButton(treeName);
      } else if (
        data["Unbounded"] === "N" &&
        !noChild &&
        elementType === "doclist"
      ) {
        setShowMapButton(treeName);
      } else if (
        data["Unbounded"] === "Y" &&
        !noChild &&
        elementType === "doclist"
      ) {
        setShowMapButton(treeName);
      } else if (
        data["Unbounded"] === "Y" &&
        !noChild &&
        (elementType === "listview" ||
          elementType === "doclist" ||
          elementType === "table" ||
          elementType === "advancelistView" ||
          elementType === "advancelistview" ||
          elementType === "frame")
      ) {
        let isSimpleGrid = true;
        if (dataObj.children) {
          let parentDetail = undefined;
          if (dataObj["treeName"].includes(".")) {
            parentDetail = getParentType(dataObj);
          }
          if (
            parentDetail &&
            parentDetail["Unbounded"] === "Y" &&
            parentDetail.children
          ) {
            setShowMapButton("");
          } else {
            setShowMapButton(treeName);
          }
        }
        if (
          isSimpleGrid &&
          (elementType === "table" || elementType === "listview")
        ) {
          setShowMapButton(treeName);
        }
      } else if (
        data["Unbounded"] === "N" &&
        noChild &&
        elementType === "datepick" &&
        data["VariableType"] === "Date" &&
        selectedControl.style["PickerType"] === "2"
      ) {
        setShowMapButton(treeName);
      } else if (
        data["Unbounded"] === "N" &&
        noChild &&
        elementType === "datepick" &&
        (data["VariableType"] === "Short Date" ||
          data["VariableType"] === "shortDate") &&
        selectedControl.style["PickerType"] === "1"
      ) {
        if (showMapButton === "") {
          setShowMapButton(treeName);
        }
      } else if(
        data["Unbounded"] === "N" &&
        noChild && 
        data["VariableType"].toLowerCase() === "boolean" &&
        (elementType === "toggle" || elementType === "radio" || elementType === "checkbox")){
          if (showMapButton === "") {
            setShowMapButton(treeName);
          }
      }
      else if( data["Unbounded"] === "N" &&
        noChild &&
        selectedControl?.style?.["isRichTextEditor"]?.toString() === "true" && data["VariableType"] === "Float"){
          if (showMapButton !== "") {
            setShowMapButton("");
          }
      }
        else if (
        data["Unbounded"] === "N" &&
        noChild &&
        elementType !== "listbox" &&
        elementType !== "listview" &&
        elementType !== "table" &&
        elementType !== "advancelistView" &&
        elementType !== "advancelistview" &&
        elementType !== "datepick" &&
        data["VariableType"] !== "Date" &&
        elementType !== "frame" && elementType !== "toggle" &&
        parentFrameBuffer?.style?.SectionKeyField !== data["VariableName"]
        && data["VariableType"].toLowerCase() !== "boolean" && data["VariableType"] !== "shortDate" &&
        data["VariableType"] !== "Short Date" 
      ) {
        setShowMapButton(treeName);
      }
    }
    event.stopPropagation();
  }

  var inputStyleForParent = {
    backgroundColor: "#0072C619",
    alignItems: "baseline",
  };

  var inputStyle = {
    alignItems: "baseline",
  };

  var inputStyleDisabled = {
    pointerEvents: 'none',
    opacity: 0.5,
    cursor: 'not-allowed',
}


  return (
    <li
      className={styles.parentChild}
      style={
        showMapButton === node["treeName"] ? inputStyleForParent : (parentFrameBuffer?.dataclass && parentFrameBuffer?.style?.SectionKeyField === node["VariableName"]) ? inputStyleDisabled : inputStyle
      }
    >
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={(event) => fetchingAllDataObjects(node)}
      >
        <div className="d-flex align-items-baseline">
          {hasChild && (
            <div>
              {childVisible ? (
                <span className={styles.iconStyle}>
                  <ExpandMoreIcon />
                </span>
              ) : (
                <span className={styles.iconStyle}>
                  <ChevronRightIcon />
                </span>
              )}
              &nbsp;
            </div>
          )}
          {node["isMapped"] === true ||
          currentMappedDO.includes(node["treeName"]) ? (
            <div
              style={
                translationStyles1
                  ? { marginRight: "10px" }
                  : { marginLeft: "2px" }
              }
            >
              {mapId === node["treeName"] ||
              currentMappedDO.includes(node["treeName"]) ? (
                <span
                  style={translationStyles1 ? null : { marginLeft: "-7px" }}
                >
                  <GreenCheckbox
                    icon={
                      <FiberManualRecordOutlinedIcon
                        style={{ fontSize: "13px", color: "black" }}
                      />
                    }
                    checkedIcon={
                      <FiberManualRecordIcon
                        style={{ fontSize: "13px", marginTop: "-3px" }}
                      />
                    }
                    checked={true}
                  />
                </span>
              ) : (
                <span
                  style={translationStyles1 ? null : { marginLeft: "-7px" }}
                >
                  <GreenCheckbox
                    icon={
                      <FiberManualRecordOutlinedIcon
                        style={{
                          fontSize: "13px",
                          color: "black",
                          marginTop: "-3px",
                        }}
                      />
                    }
                    checkedIcon={
                      <FiberManualRecordIcon
                        style={{ fontSize: "13px", marginTop: "-3px" }}
                      />
                    }
                    checked={true}
                  />
                </span>
              )}
            </div>
          ) : (
            <span
              style={
                !translationStyles1
                  ? { marginLeft: "-7px" }
                  : { marginLeft: "-7px", margin: "0.7rem" }
              }
            >
              <BlueCheckbox
                icon={
                  <FiberManualRecordOutlinedIcon
                    style={{
                      fontSize: "13px",
                      color: "black",
                      marginTop: "-3px",
                    }}
                  />
                }
                checkedIcon={
                  <FiberManualRecordIcon
                    style={{ fontSize: "13px", marginTop: "-3px" }}
                  />
                }
                checked={mapId === node["treeName"] ? true : false}
              />
            </span>
          )}
          <span
            className={
              (node.children && node.children?.length !== 0) ||
              node["MappingInfo"]
                ? styles.parentNameStyle
                : styles.variableNameStyle
            }
            title={node["VariableName"]}
            onClick={(event) => setMapButton(event, node)}
            onDoubleClick={(event) => returnOnlySelectedNode(event, node)}
          >
            {" "}
            {node["VariableName"]}{" "}
          </span>
          &nbsp;
          {!hasChild ? (
            <>
              <span className={styles.variableTypeClass}>
                {" "}
                ({" "}
                {node["Unbounded"] === "Y"
                  ? `Array`
                  : node["VariableType"] === "Short Date"
                  ? `Date`
                  : node["VariableType"] === "Date"
                  ? `Date & Time`
                  : node["VariableType"]}{" "}
                )
              </span>
            </>
          ) : null}
        </div>
        <div>
          {((showMapButton === node["treeName"] &&
            !currentMappedDO.includes(node["treeName"]) &&
            node["isMapped"] !== true) || 
            (showMapButton === node["treeName"] && elementType === "frame") ||
            (showMapButton === node["treeName"] && parentFrameBuffer) )
            ? 
            (
            <button
              className={styles.mapButtonStyle}
              style={{
                margin: "0px !impoertant",
                marginLeft: "20px !important",
                borderRadius: "3px",
                width: "40px",
                marginBottom: "5px !important",
                marginTop: "5px",
              }}
              onClick={(event) =>
                isWS ? null : setMappingOnControl(event, node)
              }
            >
              {" "}
              {t("translation:Map")}{" "}
            </button>
          ) : null}
          {mapId === node["treeName"] ? (
            <>
              <span
                className={styles.unMapButtonStyle}
                onClick={(event) => JsonUnMapButtonParent(event, node)}
              >
                {" "}
                {t("translation:UnMap")} &nbsp; <RedCross />{" "}
              </span>
            </>
          ) : null}
        </div>
      </div>

      {hasChild && childVisible && (
        <div className="d-tree-content">
          <ul className="d-flex d-tree-container flex-column">
            <Tree
              data={node["children"]}
              setCurrentMappedElement={setCurrentMappedElement}
              elementType={elementType}
              mapId={mapId}
              setMapId={setMapId}
              setMapValue={setMapValue}
              setMapType={setMapType}
              showMapButton={showMapButton}
              setShowMapButton={setShowMapButton}
              setUnmapJsonState={setUnmapJsonState}
              setDataMapId={setDataMapId}
              setParentObj={setParentObj}
              processVal={processVal}
              setProcessVal={setProcessVal}
              mapBoundValue={mapBoundValue}
              setMapBoundValue={setMapBoundValue}
              setUpdateList={setUpdateList}
              setMapVariableType={setMapVariableType}
              setVarPrecision={setVarPrecision}
              selectedVariableCallback={selectedVariableCallback}
              setVariableLength={setVariableLength}
              setDataObjectType={setDataObjectType}
              setUnBounded={setUnBounded}
              setSnackBarInfo={setSnackBarInfo}
              setAlertMsg={setAlertMsg}
              handleClose1={handleClose1}
              mappedContentForAdvance={mappedContentForAdvance}
            />
          </ul>
        </div>
      )}
      {
        alertData.open === true &&
      <CustomizedAlert alertData={alertData} />
      }
    </li>
  );
};

export default TreeNode;
